import type { ProspectResult } from '@orion/contracts';

/** A static (non-interactive) map — the Google Maps JavaScript SDK needs
 * its own API key loaded client-side; this stays consistent with the rest
 * of Prospecting keeping GOOGLE_MAPS_API_KEY server-only, at the cost of
 * pan/zoom/click. `/prospecting/map` proxies the actual Google Static Maps
 * image server-side rather than the browser hitting Google directly. */
export function ProspectMap({ results }: { results: ProspectResult[] }) {
  const withCoords = results.filter((r) => r.address.lat !== undefined && r.address.lng !== undefined);
  if (withCoords.length === 0) return null;

  const centerLat = withCoords.reduce((sum, r) => sum + r.address.lat!, 0) / withCoords.length;
  const centerLng = withCoords.reduce((sum, r) => sum + r.address.lng!, 0) / withCoords.length;
  const markers = withCoords.map((r) => `${r.address.lat},${r.address.lng}`).join('|');
  const src = `/api/v1/prospecting/map?lat=${centerLat}&lng=${centerLng}&markers=${encodeURIComponent(markers)}`;

  return (
    <div className="overflow-hidden rounded-dialog border border-border shadow-card">
      <img src={src} alt={`Map of ${withCoords.length} result${withCoords.length === 1 ? '' : 's'}`} className="block h-auto w-full" width={640} height={360} />
    </div>
  );
}
